import NameMatch from './NameMatch';

export default NameMatch;
export { defaultNameMatchDocs } from './NameMatch';
